import { Observable, throwError, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { IValidationResponse } from '@libs/types';

export abstract class ApiService {
  getStart(resultCount: number, pageIndex: number): number {
    return resultCount * pageIndex + 1;
  }

  getPageIndex(start: number, pageSize: number): number {
    return Math.ceil(start / pageSize) - 1;
  }

  catchValidationError<T extends IValidationResponse>(
    obs: Observable<T>,
  ): Observable<T> {
    return obs.pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 412) {
          const response = { validationMessages: err.error.messages } as T;
          response.validationMessages = err.error.messages;

          return of(response);
        }

        return throwError(err);
      }),
    );
  }

  cleanQuerystringParams(query: Object): HttpParams {
    let params: HttpParams = new HttpParams(query);
    Object.keys(query).forEach((key) => {
      if (query[key] instanceof Array) {
        if (query[key].length) {
          Object.keys(query[key]).forEach(
            (queryArrayKey) =>
              (params = params.append(key, query[key][queryArrayKey])),
          );
        }
      } else if (
        query[key] !== null &&
        query[key] !== undefined &&
        query[key] !== ''
      ) {
        params = params.append(key, query[key]);
      }
    });

    return params;
  }
}
